import { type PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/auth-provider";
import { LoadingScreen } from "@/components/loading-screen";

export function RequireAuth({ children }: PropsWithChildren): JSX.Element {
  const { loading, authRequired, me, sessionExpired } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;
  if (authRequired || !me) {
    return <Navigate to="/login" replace state={{ from: location, sessionExpired }} />;
  }
  return <>{children}</>;
}
